import { render, staticRenderFns } from "./PerdrawCoor.vue?vue&type=template&id=764706f6"
import script from "./PerdrawCoor.vue?vue&type=script&lang=js"
export * from "./PerdrawCoor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports